import { LinkedinLogo } from "@phosphor-icons/react";

import {
  MobileSelectionList,
  MobileSelectionListItem,
} from "common/components/MobileSelectionList";
import ProfileImage from "common/components/ui/ProfileImage";
import Skeleton from "common/components/ui/Skeleton";
import type { LinkedInProfile } from "common/types";

interface SearchMobileListProps {
  profiles: LinkedInProfile[];
  isLoading: boolean;
  totalItemCount: number;
}

export default function SearchMobileList({
  profiles,
  isLoading,
  totalItemCount,
}: SearchMobileListProps) {
  return (
    <MobileSelectionList
      title="Leads"
      data={profiles || new Array(20).fill(null)}
      selection={[]}
      totalDataCount={totalItemCount}
    >
      {(profile, listItemProps) => {
        if (isLoading) {
          return (
            <MobileSelectionListItem {...listItemProps}>
              <Skeleton className="size-8 shrink-0 rounded-full" />
              <Skeleton className="h-4 w-28" />
            </MobileSelectionListItem>
          );
        }

        const { picture_url, full_name, premium, occupation, location } =
          profile;

        return (
          <MobileSelectionListItem {...listItemProps}>
            <ProfileImage size="sm" src={picture_url} />

            <div className="flex min-w-0 flex-1 flex-col text-left">
              <div className="flex items-center gap-x-1">
                <span className="truncate text-sm-bold">{full_name}</span>
                {premium && (
                  <LinkedinLogo
                    className="size-4 shrink-0 text-yellow-500"
                    weight="fill"
                  />
                )}
              </div>
              <span className="truncate text-xs-medium text-black-500">
                {[occupation, location?.name].filter(Boolean).join(" · ")}
              </span>
            </div>
          </MobileSelectionListItem>
        );
      }}
    </MobileSelectionList>
  );
}
